import { ContentContainer } from "@Components/forecast/ContentContainer";
import { DailyWeatherOverview } from "@Components/forecast/DailyWeatherOverview";
import { NavigationContainer } from "@Components/forecast/hourly/NavigationContainer";
import { TeaserContainer } from "@Components/teaser/TeaserContainer";
import { REPRESENTATIONS } from "@Constants/representation";
import { useScrollInteractions } from "@Hooks/useScrollInteractions";

export const WeatherDetailsContainer = () => {
  const {
    containerRefs,
    dayRefs,
    canNavigateLeft,
    canNavigateRight,
    navigateLeft,
    navigateRight,
    handleScroll,
    handleMouseWheelScroll,
  } = useScrollInteractions();

  return (
    <ContentContainer className="m:justify-normal! m:overflow-hidden m:bg-warmgrey-10 m:py-6 m:md:px-0 m:lg:justify-center! m:dark:bg-blue-950">
      <DailyWeatherOverview />
      {REPRESENTATIONS.map((representation, index) => (
        <NavigationContainer
          key={index}
          representation={representation}
          ref={containerRefs.current[representation]}
          dayRefs={dayRefs ?? []}
          canNavigateLeft={canNavigateLeft}
          canNavigateRight={canNavigateRight}
          navigateLeft={navigateLeft}
          navigateRight={navigateRight}
          handleScroll={handleScroll}
          handleMouseWheelScroll={handleMouseWheelScroll}
        />
      ))}
      <TeaserContainer />
    </ContentContainer>
  );
};
